import type { Application } from '@/types';

/** Client-side unread check — prefers server `isUnread`, falls back to timestamp compare. */
export function isApplicationUnread(app: Application): boolean {
  if (typeof app.isUnread === 'boolean') return app.isUnread;
  const revision = app.inboxRevisionAt ?? app.appliedAt;
  if (!app.viewedAt) return true;
  return Date.parse(app.viewedAt) < Date.parse(revision);
}

/** Sort key: unread first (0) when ascending. */
export function getApplicationInboxSortValue(app: Application): number {
  return isApplicationUnread(app) ? 0 : 1;
}

export function applicationInboxPatchFromResponse(
  app: Application,
  patch: Pick<Application, 'inboxRevisionAt' | 'viewedAt' | 'isUnread'>,
): Application {
  return {
    ...app,
    inboxRevisionAt: patch.inboxRevisionAt ?? app.inboxRevisionAt,
    ...(patch.viewedAt !== undefined ? { viewedAt: patch.viewedAt } : {}),
    isUnread: patch.isUnread ?? isApplicationUnread({ ...app, ...patch }),
  };
}
